import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-loader-spinner',
  templateUrl: './local-loader-spinner.component.html',
  styleUrls: ['./local-loader-spinner.component.scss']
})
export class LocalLoaderSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
